import { AxiosInstancePlus } from '@tencent/oneid-request';
import type { IAccount } from 'common/constants/Types';
import { http } from 'common/http';

class AccountApiV3 {
  public axiosInstance: AxiosInstancePlus = http;

  /**
   * 获取企业信息
   */
  getAccountInfo(): Promise<IAccount> {
    return http.get('/admin/v3/account');
  }
}
export default new AccountApiV3();
